const ROOT_URL = 'https://admin.alfadent.digifeel.cz';
//const ROOT_URL = 'http://localhost:3000';

export const AUTH_CONFIG = {
  domain: 'alfadent.eu.auth0.com',
  clientId: 'Ew4P5RdCM92xE1XithMpY433fOjQBevD',
  callbackUrl: `${ROOT_URL}/callback`,
  returnTo: `${ROOT_URL}/prihlaseni`,
  apiUrl: 'Alfadent',
  responseType: 'token id_token'
};



// WEBPACK FOOTER //
// ./src/services/auth/auth0-variables.js